var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#25D366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.196 11.934a7.32 7.32 0 0 0 .98 3.666l-1.041 3.799 3.888-1.02a7.33 7.33 0 0 0 3.505.893h.004c4.042 0 7.333-3.29 7.334-7.332.001-1.96-.761-3.802-2.146-5.188a7.29 7.29 0 0 0-5.188-2.15c-4.044 0-7.334 3.288-7.336 7.332Zm2.316 3.474-.145-.23a6.077 6.077 0 0 1-.932-3.244 6.104 6.104 0 0 1 6.099-6.095c1.628.001 3.159.636 4.31 1.788a6.056 6.056 0 0 1 1.784 4.312 6.104 6.104 0 0 1-6.097 6.094h-.002a6.09 6.09 0 0 1-3.103-.85l-.223-.131-2.307.605.616-2.25Zm5.02 3.864Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.699 8.868c-.138-.305-.282-.311-.413-.317-.107-.004-.229-.004-.35-.004a.674.674 0 0 0-.49.23c-.168.183-.641.626-.641 1.528s.656 1.773.748 1.895c.092.122 1.268 2.032 3.13 2.767 1.549.61 1.864.489 2.2.458.336-.03 1.084-.443 1.237-.871.153-.428.153-.795.107-.871-.046-.077-.168-.123-.351-.214-.184-.092-1.085-.535-1.253-.596-.168-.061-.29-.092-.412.091-.122.184-.473.596-.58.719-.107.122-.214.137-.398.046-.183-.092-.773-.285-1.473-.91a5.534 5.534 0 0 1-1.02-1.269c-.107-.183-.012-.283.08-.374.083-.082.184-.214.275-.32.092-.108.122-.184.183-.306.061-.123.031-.23-.015-.322-.045-.091-.402-.998-.564-1.36Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.bfc33588a9a66268f27604c35783e1c1.svg";
export { ForwardRef as ReactComponent };